import { useLazyRef } from '@studio/react-utils/hooks';
import type { ReactElement } from 'react';
import { Grid } from './grid.jsx';
import type { Props } from './types.js';
import { useWiring } from './wiring.js';
import { Section } from '#~/room/components/common/section/index.js';

/** `<QuickShots>` component. */
export const QuickShots = ({ deviceId, ...props }: Props): ReactElement => {
  const { capabilities, handleHome, handleMovement, intent, isHoming, isStopping } = useWiring({
    deviceId
  });

  // Stabilize handler.
  const handler = useLazyRef(() => ({
    onHome: handleHome,
    onMovement: handleMovement
  })).current;

  return (
    <Section label='Quick Shots' slug='quick-shots' {...props}>
      {/* Be very careful w/ memoization here! */}
      <Grid
        capabilities={capabilities}
        handler={handler}
        intent={intent}
        isHoming={isHoming}
        isStopping={isStopping}
      />
    </Section>
  );
};
